var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "15px", "margin-bottom": "45px" } },
    [
      _c(
        "v-card",
        { attrs: { color: _vm.dark ? "primary" : "", dark: _vm.dark } },
        [
          _c("v-card-text", { staticClass: "relative pb-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "relative shift-up elevation-6 w-full py-1 px-1 top-right-rounded rounded white--text",
                class: "bg-" + _vm.color
              },
              [
                _c("span", {
                  staticClass: "text-uppercase oswald-font-family title",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "-30px" } },
              [_vm._t("default")],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }